export default {
	data() {
		return {

		}
	},
	mounted() {
		this.setSelectedPosition();
	},
	methods: {
		// 设置已选配置位置
		setSelectedPosition() {
			$('.mainCon').scroll(function () {
				if ($(this).scrollTop() > 140) {
					$('.jc-form-create-selected').css({ 'position': 'fixed', 'top': '10px' });
				} else {
					$('.jc-form-create-selected').css({ 'position': 'absolute', 'top': '30px' });
				}
			});
		},
	}
}




// WEBPACK FOOTER //
// ./src/mixins/initSelectedPotision.js